// src/components/AgeretProductDetail.jsx

import React, { useState } from "react";
import "../assets/css/AgeretProductDetail.css";
import mainImage from "../assets/images/New-Products/Cumax.jpg";
import thumb1 from "../assets/images/All-Products/Cumax2.jpg";
import thumb2 from "../assets/images/New-Products/Cumax.jpg";
import thumb3 from "../assets/images/All-Products/Cumax2.jpg";
import howToUseThumb from "../assets/images/skin-breadcrum.jpg";
import howToUseVideo from "../assets/Video/0_Molecular_Cosmetics_1920x1080 (1).mp4";
import BredcrumpImage from "../assets/images/skin-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";



const AgeretProductDetails = () => {
  const [selectedImage, setSelectedImage] = useState(mainImage);
  const [activeTab, setActiveTab] = useState("benefits");
  const [showVideo, setShowVideo] = useState(false);

  return (
    <>

      <BreadcrumbSection
        title="Empowering Confidence Through Skin Health."
        // subtitle="Committed to Excellence:"
        breadcrumbItems={[
          { label: "Home", to: "/" }, { label: "Skin Care", to: "/Skin-Care-Products" },

        ]}
        backgroundImage={BredcrumpImage}
      />

      <section className="product-details-section">

        <div className="container product-container">
          {/* Product Image and Details */}
          <div className="product-info">
            <div className="product-image-section">
              <img src={selectedImage} alt="Ageret Product" className="main-image" />
              <div className="thumbnail-row">
                {[thumb2].map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt={`Thumbnail ${i + 1}`}
                    className={`thumbnail ${selectedImage === img ? "active-thumb" : ""}`}
                    onClick={() => setSelectedImage(img)}
                  />
                ))}
              </div>
            </div>

            <div className="product-description">
              <h2>Cumax </h2>
              <p className="sub-heading text-muted">Immunity Booster </p>
              <h5>Product Overview</h5>
              <p>
                A novel approach for the management of skin inflammatory disorders at cellular level.
                Cumax consists of 95% of bioavailable curcuminoids (CurQlife) along with L Methyl Folate & Flax Seed Oil.
                CurQlife is patented for its highly bioavailable extracts which is possible due to the HLB (Hydrophilic Lipophilic Balance)
                Technology for enhanced pharmacokinetics, solubility, stability and sustained release.

              </p>
            </div>
          </div>

          {/* How To Use Section */}
          {/* <div className="how-to-use-section" data-aos="fade-up">
            <div
              className="how-to-use-content"
              style={{
                backgroundImage: `url(${howToUseThumb})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="text-content">
                <h3>
                  How To Use <span className="highlight">Cumax?</span>
                </h3>
                <p>
                  Use this medicine in the dose and duration as advised by your doctor. Check the label for directions before use.
                </p>
              </div>
              <div className="video-thumbnail-wrapper" onClick={() => setShowVideo(true)}>
                <div className="video-thumbnail">
                  <i className="bi bi-play-fill play-icon"></i>
                </div>
              </div>
            </div>
          </div> */}

          {/* Video Popup Modal */}
          {showVideo && (
            <div className="video-popup">
              <div className="video-container">
                <video controls autoPlay>
                  <source src={howToUseVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>

                {/* Uncomment this block to use YouTube later */}
                {/*
              <iframe
                src="https://www.youtube.com/embed/VIDEO_ID?autoplay=1"
                title="How to Use Ageret"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
              ></iframe>
              */}

                <button className="close-btn" onClick={() => setShowVideo(false)}>
                  &times;
                </button>
              </div>
            </div>
          )}

          {/* Accordion Section */}
          <div className="accordion-section">
            <div className="accordion-tabs">
              {["benefits", "application", "ingredients"].map((tab) => (
                <button
                  key={tab}
                  className={`accordion-tab ${activeTab === tab ? "active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab === "benefits"
                    ? "BENEFITS"
                    : tab === "application"
                      ? "APPLICATION GUIDELINES"
                      : tab === "ingredients"
                        ? "INGREDIENTS"
                        : "BEFORE–AFTER"}
                </button>
              ))}
            </div>

            <div className="accordion-content">
              {activeTab === "benefits" && (
                <div className="tab-content fade-in">

                  <ul>
                    <li><strong>High Bioavailability:</strong> CurQlife delivers 50-fold higher free curcumin levels in blood compared to unformulated curcuminoids.</li>
                    <li><strong>Enhanced Solubility:</strong> Delivers high-quality bioactive free curcumin to the blood. CurQlife® is a highly bioavailable form of curcuminoids due to HLB technology, which increases solubility and reduces metabolic degradation.</li>
                  </ul>

                </div>
              )}
              {activeTab === "application" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li>1-2 Capsules to be taken daily.</li>

                    </ul>

                  </p>
                </div>
              )}
              {activeTab === "ingredients" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li><strong>CurQlife:</strong> Acts as a bioprotectant and antioxidant, quenching free radicals and preventing their formation. CurQlife has been shown to be a COX-2 (Cyclooxygenase-2) inhibitor. Curcuminoids support a healthy immune system and prevent connective tissue breakdown by inhibiting destructive enzymes.</li>
                      <li><strong>L-Methyl Folate:</strong> The predominant and active form of folate. Plays a vital role in hyperhomocysteinemia, an independent risk factor in psoriasis complications.</li>
                      <li><strong>Flax Seed Oil:</strong> Rich in Omega 3, 6 & 9, crucial for the skin's fat content and lipid barrier. Plays a vital role in preventing photoaging.</li>
                    </ul>


                  </p>
                </div>
              )}



            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default AgeretProductDetails;
